<script lang="ts" setup>
import AppButton from "~/components/ui/buttons/AppButton.vue";
import apiConfig from "~/shared/config/api";
import customFetch from "~/composables/custom-fetch";

const props = defineProps<{
  email: string
}>()

const emits = defineEmits(['pass-errors', 'pass-response'])
const {auth} = apiConfig
const mailRegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

async function resetPassword() {
  const errors = []
  if (props.email.match(mailRegExp)) {
    const res = await customFetch(auth.resetPassword({email: props.email}));
    if (!res.success) {
      if (res.status === 422) {
        errors.push('emailNotExist')
      } 
      if (res.status === 409 && res.errors) {
        errors.push('emailDeleted', res.errors[0].message)
      }
      emits('pass-errors', errors)
    } else {
      emits('pass-response', props.email)
    }
  } else {
    if (props.email) {
      errors.push('emailFormat')
    } else {
      errors.push('emailEmpty')
    }

    emits('pass-errors', errors)
  }
}
</script>

<template>
  <AppButton
    text="Сбросить текущий пароль"
    size="l"
    @click="resetPassword"
  />
</template>

<style lang="scss" scoped>
.button {
  width: 100%;
}
</style>
